module.exports = __webpack_public_path__ + "img/kz35_173.asm.ce6ae9cd.jpg";